import { PasswordScreen } from "@/interactors/PasswordScreen";

export default function Password() {
  return <PasswordScreen />;
}
